'use strict';

var dateFns = require('date-fns');
var parsers = require('../parsers.cjs');
var disassembleISODatePartToParts = require('./disassembleToParts/disassembleISODatePartToParts.cjs');
var disassembleISODatePartWithoutYearToParts = require('./disassembleToParts/disassembleISODatePartWithoutYearToParts.cjs');
var isISODatePartWithoutYear = require('./isISODatePartWithoutYear.cjs');

function isAnniversary(targetDate, anniversaryBaseDate) {
  const anniversaryParts = isISODatePartWithoutYear(anniversaryBaseDate) ? disassembleISODatePartWithoutYearToParts(anniversaryBaseDate) : disassembleISODatePartToParts(anniversaryBaseDate);
  const targetDateParts = disassembleISODatePartToParts(targetDate);
  const \uAE30\uB150\uC77C\uC774_\uC724\uC77C\uC784 = anniversaryParts.month === 2 && anniversaryParts.day === 29;
  const \uD0C0\uAC9F\uC77C\uC774_\uD3C9\uB144_2\uC6D4_28\uC77C\uC784 = !dateFns.isLeapYear(parsers.isoDatePartToDate(targetDate)) && targetDateParts.month === 2 && targetDateParts.day === 28;
  if (\uAE30\uB150\uC77C\uC774_\uC724\uC77C\uC784 && \uD0C0\uAC9F\uC77C\uC774_\uD3C9\uB144_2\uC6D4_28\uC77C\uC784) {
    return true;
  }
  return targetDateParts.month === anniversaryParts.month && targetDateParts.day === anniversaryParts.day;
}

module.exports = isAnniversary;
//# sourceMappingURL=isAnniversary.cjs.map
